import { decl } from '@yandex-lego/i-bem-react';
import _iServices__uri from "./__uri/i-services__uri.react.js";

var Uri = _iServices__uri.applyDecls();

var i18n = function () {
    var core = require('bem-i18n');

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'ru' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'ru' : 'en' === 'ru') {
        return core().decl(require('./i-services.i18n/ru'))('i-services');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'en' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'en' : 'en' === 'en') {
        return core().decl(require('./i-services.i18n/en'))('i-services');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'be' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'be' : 'en' === 'be') {
        return core().decl(require('./i-services.i18n/be'))('i-services');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'id' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'id' : 'en' === 'id') {
        return core().decl(require('./i-services.i18n/id'))('i-services');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'kk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'kk' : 'en' === 'kk') {
        return core().decl(require('./i-services.i18n/kk'))('i-services');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tr' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tr' : 'en' === 'tr') {
        return core().decl(require('./i-services.i18n/tr'))('i-services');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'tt' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'tt' : 'en' === 'tt') {
        return core().decl(require('./i-services.i18n/tt'))('i-services');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uk' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uk' : 'en' === 'uk') {
        return core().decl(require('./i-services.i18n/uk'))('i-services');
    }

    if (process.env.BEM_LANG ? process.env.BEM_LANG === 'uz' : process.env.REACT_APP_BEM_LANG ? process.env.REACT_APP_BEM_LANG === 'uz' : 'en' === 'uz') {
        return core().decl(require('./i-services.i18n/uz'))('i-services');
    }

    if (process.env.NODE_ENV === 'development') {
        process.env.BEM_LANG && console.error('No match of process.env.BEM_LANG { ' + process.env.BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk, uz }');
        process.env.REACT_APP_BEM_LANG && console.error('No match of process.env.REACT_APP_BEM_LANG { ' + process.env.REACT_APP_BEM_LANG + ' } in provided langs: { ru, en, be, id, kk, tr, tt, uk, uz }');
    }

    return function () {};
}();

var CONTENT_REGION = 'ru';

export default decl({
    block: 'i-services'
}, {
    serviceName: function serviceName(id) {
        return i18n(id);
    },
    serviceUrl: function serviceUrl(id) {
        var region = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : CONTENT_REGION;

        return Uri[id](region);
    }
});